<template>
  <v-card
    outlined
    class="my-2"
    loader-height="8"
    :loading="admin.attributeValuesLoading"
    :disabled="admin.attributeValuesLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5">
          Delete Attribute Value ({{ label }})?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteAttributeValue">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedAttributeValue == null"></v-card-text>
    <v-card-text v-show="admin.selectedAttributeValue != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Attribute Value saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-text-field
          v-model="label"
          :rules="validation.length50"
          label="Label"
          required
        ></v-text-field>
        <v-text-field
          v-model="value"
          :rules="validation.length100"
          label="Value"
          required
        ></v-text-field>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedAttributeValue != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveAttributeValue"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteAttributeValue"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedAttributeValue &&
            this.admin.selectedAttributeValue.id != 'new'
          ) {
            tabName = `Edit Attribute Value [${this.admin.selectedAttributeValue.label}]`;
          } else if (
            this.admin.selectedAttributeValue &&
            this.admin.selectedAttributeValue.id == 'new'
          ) {
            tabName = 'Add New Attribute Value';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedAttributeValue?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttributeValue',
            property: 'id',
            value: value
          });
        }
      },
      attributeId: {
        get() {
          return this.admin.selectedAttributeValue?.attributeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttributeValue',
            property: 'attributeId',
            value: value
          });
          this.$store.dispatch('admin/getAttributeValueList', value);
        }
      },
      label: {
        get() {
          return this.admin.selectedAttributeValue?.label;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttributeValue',
            property: 'label',
            value: value
          });
        }
      },
      value: {
        get() {
          return this.admin.selectedAttributeValue?.value;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttributeValue',
            property: 'value',
            value: value
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedAttributeValue?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttributeValue',
            property: 'published',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a product
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedAttributeValue', null);
      },
      /**
       * Saves the product currently being edited
       */
      saveAttributeValue() {
        this.$store.dispatch('admin/saveSelectedAttributeValue').then(() => {
          this.showSaveOverlay = true;
          // refresh product list
          this.$store.dispatch('admin/getAttributeValueList', this.attributeId);
          setTimeout(() => {
            this.showSaveOverlay = false;
          }, 1500);
        });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteAttributeValue() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product setting
       */
      deleteAttributeValue() {
        this.$store
          .dispatch('admin/deleteSelectedAttributeValue', this.id)
          .then(() => {
            this.$store.dispatch(
              'admin/getAttributeValueList',
              this.attributeId
            );
            this.showConfirmationDialog = false;
            this.$store.commit('admin/setSelectedAttributeValue', null);
          });
      }
    }
  };
</script>

<style scoped></style>
